const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-tabs ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    tabs: Array,
    active: String,
    vertical: Boolean,
  }

  onMount() {
    this.reveal()
  }

  afterRender() {
    this.reveal()
  }

  // When the tabs scroll sideways (a narrow screen), keep the active one in view.
  reveal() {
    const nav = this.state.nav
    const active = nav && nav.querySelector('a.active')
    if (!active || nav.scrollWidth <= nav.clientWidth) return
    const tab = active.getBoundingClientRect()
    const box = nav.getBoundingClientRect()
    if (tab.left < box.left || tab.right > box.right) nav.scrollLeft += tab.left - box.left - 16
  }

  CSS = `:fez {
display:block;nav{display:flex;gap:var(--space-1);border-bottom:1px solid var(--color-border);overflow-x:auto;scrollbar-width:none}a{display:inline-flex;align-items:center;gap:var(--space-2);padding:var(--space-2) var(--space-3);margin-bottom:-1px;border-bottom:2px solid transparent;color:var(--color-text-muted);font-size:var(--text-sm);font-weight:var(--weight-semibold);white-space:nowrap;text-decoration:none;transition:color var(--duration-fast) var(--ease),background var(--duration-fast) var(--ease);&:hover{color:var(--color-text);text-decoration:none}&.active{color:var(--color-text);border-bottom-color:var(--color-accent)}}.vertical{flex-direction:column;gap:2px;border-bottom:0;a{margin:0;padding:var(--space-2) var(--space-3);border:0;border-radius:var(--radius-md);&:hover{background:var(--color-bg-hover)}&.active{background:var(--color-selected-bg);color:var(--color-selected-text)}} :mobile {flex-direction:row;gap:var(--space-1);border-bottom:1px solid var(--color-border);a{margin-bottom:-1px;border-bottom:2px solid transparent;border-radius:0;&:hover{background:transparent}&.active{background:transparent;color:var(--color-text);border-bottom-color:var(--color-accent)}}}}
}`

  HTML = `<nav fez:this="nav" class:vertical={props.vertical} role="tablist">
{#each props.tabs as tab}
<a href={tab.href} class:active={tab.id === props.active} role="tab" aria-selected={tab.id === props.active ? 'true' : 'false'}>
{#if tab.icon}
<ui-icon name={tab.icon} size="16"></ui-icon>
{/if}
{tab.label}
</a>
{/each}
</nav>`
};
}

Fez('ui-tabs', __fez_component_0);

export default __fez_component_0;
